import { HttpClient } from '@angular/common/http';
import { Platform } from '@ionic/angular';
import { CordovaRequestor } from 'ionic-appauth/lib/cordova';
import { NgHttpService } from '../ng-http.service';

// eslint-disable-next-line max-len
export const httpFactory = (platform: Platform, handler: HttpClient) => platform.is('cordova') ? new CordovaRequestor() : new NgHttpService(handler);
